import PerfilPerson from "@/components/functionals/PerfilPerson.vue";
import ImagePersonByEmployee from "@/components/functionals/ImagePersonByEmployee.vue";
import ColorColumnsEmployee from "./formatterColumn.vue";
export const ColumnsEmployeeACT = [
  {
    prop: "Name",
    name: "Nombre",
    minWidth: 370,
    fixed: true,
    formatter: PerfilPerson
  },

  {
    pro: "Direccion.Name",
    name: "Direccion",
    width: 270,
    formatter: (row) => row.Direccion.Name.substring(0, 30)
  },
  {
    pro: "Deparmento.Name",
    name: "Deparmento",
    width: 270,
    formatter: (row) => row.Deparmento.Name.substring(0, 30)
  },
  {
    pro: "Posicion.Name",
    name: "Cargo",
    width: 270,
    formatter: (row) => row.Posicion.Name.substring(0, 36)
  },
  {
    prop: "Supervisor",
    name: "Supervisor",
    minWidth: 400,
    formatter: ImagePersonByEmployee
  },
  {
    prop: "Email",
    name: "Email",
    width: 250
  },
  {
    prop: "Fleet",
    name: "Flota",
    width: 130
  },
  {
    prop: "Extension",
    name: "Ext.",
    width: 100
  },
  {
    prop: "No_Pase",
    name: "No. Pase",
    minWidth: 150
  }
];
export const ColumnsEmployeeINA = [
  {
    prop: "Name",
    name: "Nombre",
    minWidth: 370,
    fixed: true,
    formatter: PerfilPerson
  },
  {
    prop: "MotiveForDeletion",
    name: "Motivo de Salida",
    minWidth: 250,
    fixed: true,
    formatter: ColorColumnsEmployee
  },
  // {
  //   prop: "LastSalary",
  //   name: "Último Salario",
  //   minWidth: 140,
  //   fixed: true
  // },
  {
    pro: "Direccion.Name",
    name: "Direccion",
    width: 270,
    formatter: (row) => row.Direccion.Name.substring(0, 30)
  },
  {
    pro: "Deparmento.Name",
    name: "Deparmento",
    width: 270,
    formatter: (row) => row.Deparmento.Name.substring(0, 30)
  },
  {
    pro: "Posicion.Name",
    name: "Cargo",
    width: 270,
    formatter: (row) => row.Posicion.Name.substring(0, 36)
  },
  {
    prop: "Supervisor",
    name: "Supervisor",
    minWidth: 400,
    formatter: ImagePersonByEmployee
  },
  {
    prop: "Email",
    name: "Email",
    width: 250
  },
  {
    prop: "Fleet",
    name: "Flota",
    width: 130
  },
  {
    prop: "Extension",
    name: "Ext.",
    width: 100
  },
  {
    prop: "No_Pase",
    name: "No. Pase",
    minWidth: 150
  }
];
